module.exports = __webpack_public_path__ + "static/img/signature.0c48ffb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/signature.png
// module id = I1iT
// module chunks = 1